<div class="lightContent">
  <div class="headingPage">
    <h2 class="">Select Products</h2>
  </div>
    <div class="listing"
    [pageId]="'all_related_stories_embed'"
    [amazonOrSnapdeal]="amazonOrSnapdeal"
    [allApi]="'all_story'"
    [searchApi]="'all_story'"
    [suggestionApi]="'story_suggestions'"
    [metaApi]="'dashboard_meta'"
    [RelatedStorySearch]="true"
    [storyId]= "story_Id"
    [showPagination]="true"
    [multipleStories]="true"
    [storyIdArray]="storyIdList"
    [isCroma]="is_Croma"
    (sendIdToParentfn)="storySelected($event)"
    search_label="Search Products..."></div>


    <div class="right" >
      <button type="button" name="discard" class="discard blue" (click)="closePopup()">Close</button>
      <!-- [disabled]="storyIdList.length < 1" -->
      <button *ngIf="amazonOrSnapdeal == null || amazonOrSnapdeal == undefined || amazonOrSnapdeal != 'affiliate'" type="button" name="save" class="save blue" (click)="storiesSelected()" 
      [disabled]="storyIdList.length < 1"
      >Choose {{storyIdList.length}} Products</button>
    </div>
</div>